import React from "react";
import { useState, useEffect } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const statusSteps = {
  PEDIDO_FEITO: {
    progress: 0,
    text: "Pedido Feito",
  },
  PAGAMENTO_INICIAL: {
    progress: 20,
    text: "Pagamento Inicial",
  },
  EM_PRODUCAO: {
    progress: 40,
    text: "Em Produção",
  },
  ENVIADO_PARCIALMENTE: {
    progress: 60,
    text: "Enviado Parcialmente",
  },
  ENVIADO: {
    progress: 70,
    text: "Enviado",
  },
  ENTREGUE_PARCIALMENTE: {
    progress: 80,
    text: "Entregue Parcialmente",
  },
  ENTREGUE: {
    progress: 100,
    text: "Entregue",
  },
};

const CircularProgress = ({ status }) => {
  const [progress, setProgress] = useState(0);
  const [text, setText] = useState("Status desconhecido");

  console.log("status: ", status);

  useEffect(() => {
    // Atualiza o progresso e o texto com base no status passado
    const step = statusSteps[status];
    if (step) {
      setProgress(step.progress);
      setText(step.text);
    } else {
      setProgress(0); // Se o status não for reconhecido
      setText("Status desconhecido");
    }
  }, [status]); // Reexecuta o efeito apenas quando o status muda

  return (
    <div className="xl:w-[40px] xl:h-[40px] md:w-[25px] md:h-[25px] md:pr-2 flex">
      <CircularProgressbar
        value={progress}
        styles={buildStyles({
          // Cor customizada da barra
          pathColor: "#FF9533",
          textColor: "#FF9533",
          trailColor: "#D9D9D9",
          strokeWidth: 100,
        })}
      />
    </div>
  );
};

export default CircularProgress;
